import React, {useContext, useState} from 'react'
import './dashboard2.css'
import AgentContactMailIcon from 'Images/agent-contact-mail.svg'
import LadderLogo from 'Images/logo-rungs-with-text.svg'
import {SharePage2} from 'ladder/agents/dashboard/share_page2'
import {LearnPage2, SettingsPage2} from 'ladder/agents/dashboard/learn2'
import {SettingsProfilePage2, SettingsSupportPage2} from 'ladder/agents/dashboard/settings2'
import {Text} from 'ladder/ux/typography2'
import {AcceptTermsModal} from 'ladder/agents/dashboard/AcceptTermsModal'
import {NavBarAndHelpModal} from 'ladder/agents/dashboard/nav2'
import {copyright, disclaimerText} from 'ladder/footer2'
import {QueryClient, QueryClientProvider, useMutation, useQuery} from '@tanstack/react-query'
import axios from 'axios'
import {canonicalHeaders} from 'ladder/util2'
import {DashboardQueryContext} from 'ladder/agents/dashboard/DashboardQueryContext'

function MobileHeader({setAgentHelpModalVisible}) {
  return <div className='mobile-header'>
    <div className='logo-container'>
      <LadderLogo/>
    </div>
    <div className='help-container' onClick={() => setAgentHelpModalVisible(true)}>
      <div style={{display: 'flex', justifyContent: 'center'}}>
        <AgentContactMailIcon/>
      </div>
      <Text block size='body-12' color='#707070'>Have a question?</Text>
    </div>
  </div>
}

function Footer({sendBang}) {
  return <Text tag='footer' className='footer-container' size='body-12' weight='300' color='#707070'>
    {copyright({color: '#336FED', ccpa: true, minimal: true, sendBang: sendBang})}
    {disclaimerText({})}
  </Text>
}


function DashboardImpl(props) {
  const {contactDetailPageContactEmail, CljsContactsPage} = props

  const {mutation, ...q} = useContext(DashboardQueryContext)
  const isImo = q['agent/top-level-agency-lddr-source'] === 'prosperity-imo'
  const navBarPages = isImo ? ['share', 'contacts', 'settings'] : ['contacts', 'share', 'learn', 'settings']

  const [currentPage, setCurrentPage] = useState(navBarPages[0])
  const [agentHelpModalVisible, setAgentHelpModalVisible] = useState(false)

  let outerClassName = 'home'
  if (currentPage === 'share') {
    outerClassName += ' share-page-container'
  }
  if (currentPage === 'settings/profile') {
    outerClassName += ' settings-profile-page-container'
  }
  if (!!contactDetailPageContactEmail) {
    outerClassName += ' contact-details-page-container'
  }
  let PageToRender
  if (currentPage === 'contacts') {
    PageToRender = CljsContactsPage
  } else if (currentPage === 'share') {
    PageToRender = SharePage2
  } else if (currentPage === 'learn') {
    PageToRender = LearnPage2
  } else if (currentPage === 'settings') {
    PageToRender = SettingsPage2
  } else if (currentPage === 'settings/profile') {
    PageToRender = SettingsProfilePage2
  } else if (currentPage === 'settings/support') {
    PageToRender = SettingsSupportPage2
  }

  return (<div className='dashboard-root column'>
    <div className='column'>
      <AcceptTermsModal/>
      <MobileHeader setAgentHelpModalVisible={setAgentHelpModalVisible}/>
      <div className={outerClassName}>
        <div className='page-container'>
          <PageToRender {...props} onNavigate={setCurrentPage}/>
        </div>
        <div className='nav-bar-container'>
          <NavBarAndHelpModal
              agentHelpModalVisible={agentHelpModalVisible}
              setAgentHelpModalVisible={setAgentHelpModalVisible}
              isImo={isImo}
              pages={navBarPages}
              currentPage={currentPage}
              onNavigate={setCurrentPage}/>
        </div>
      </div>
    </div>
    <Footer sendBang={props.sendBang}/>
  </div>)
}

const queryClient = new QueryClient()

interface MutationData {
  def: string;
  params: Record<string, any>;
}

function DashboardQueryWrapper(props) {
  const read = useQuery({
    queryKey: ['agents-dashboard/root-query'], queryFn: () => axios
        .post('/api/agents-dashboard/root-query', null, {headers: canonicalHeaders()})
        .then(res => res.data)
  })

  const mutation = useMutation({
    mutationFn: (variables: MutationData) => {
      return axios.post('/api/agents-dashboard/mutation', variables, {headers: canonicalHeaders()})
    }, onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['agents-dashboard/root-query']})
    }
  })

  if (read.isLoading) {
    return <div>Loading...</div>
  }
  if (read.error) {
    return <div>{'An error has occurred: ' + read.error['message']}</div>
  }
  return (<DashboardQueryContext.Provider value={{...read.data, mutation}}>
    <DashboardImpl {...props}/>
  </DashboardQueryContext.Provider>)
}

export function Dashboard2(props) {
  return (<QueryClientProvider client={queryClient}>
    <DashboardQueryWrapper {...props}/>
  </QueryClientProvider>)
}
